/**
 * AV API
 * AV for GWR Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { GrundstueckFlaechenanteilMasterDetailEntry } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class AvflaechenanteilService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param grundstueckId 
     * @param timepoint 
     * @param timepointId 
     * @param historisiert 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadGrundstueckFlaechenanteilSichtGrundstueck(grundstueckId: string, timepoint?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<GrundstueckFlaechenanteilMasterDetailEntry>>;
    public loadGrundstueckFlaechenanteilSichtGrundstueck(grundstueckId: string, timepoint?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<GrundstueckFlaechenanteilMasterDetailEntry>>>;
    public loadGrundstueckFlaechenanteilSichtGrundstueck(grundstueckId: string, timepoint?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<GrundstueckFlaechenanteilMasterDetailEntry>>>;
    public loadGrundstueckFlaechenanteilSichtGrundstueck(grundstueckId: string, timepoint?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (grundstueckId === null || grundstueckId === undefined) {
            throw new Error('Required parameter grundstueckId was null or undefined when calling loadGrundstueckFlaechenanteilSichtGrundstueck.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (grundstueckId !== undefined && grundstueckId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>grundstueckId, 'grundstueckId');
        }
        if (timepoint !== undefined && timepoint !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>timepoint, 'timepoint');
        }
        if (timepointId !== undefined && timepointId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>timepointId, 'timepointId');
        }
        if (historisiert !== undefined && historisiert !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>historisiert, 'historisiert');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Array<GrundstueckFlaechenanteilMasterDetailEntry>>(`${this.configuration.basePath}/av/flaechenanteil/sicht`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param egrid 
     * @param nummer 
     * @param nummerZusatz 
     * @param nummer3 
     * @param nummer4 
     * @param bfsNummer 
     * @param kreisNummer 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadGrundstueckFlaechenanteilSichtGrundstueckByFachId(egrid?: string, nummer?: string, nummerZusatz?: string, nummer3?: number, nummer4?: number, bfsNummer?: number, kreisNummer?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<GrundstueckFlaechenanteilMasterDetailEntry>>;
    public loadGrundstueckFlaechenanteilSichtGrundstueckByFachId(egrid?: string, nummer?: string, nummerZusatz?: string, nummer3?: number, nummer4?: number, bfsNummer?: number, kreisNummer?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<GrundstueckFlaechenanteilMasterDetailEntry>>>;
    public loadGrundstueckFlaechenanteilSichtGrundstueckByFachId(egrid?: string, nummer?: string, nummerZusatz?: string, nummer3?: number, nummer4?: number, bfsNummer?: number, kreisNummer?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<GrundstueckFlaechenanteilMasterDetailEntry>>>;
    public loadGrundstueckFlaechenanteilSichtGrundstueckByFachId(egrid?: string, nummer?: string, nummerZusatz?: string, nummer3?: number, nummer4?: number, bfsNummer?: number, kreisNummer?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (egrid !== undefined && egrid !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>egrid, 'egrid');
        }
        if (nummer !== undefined && nummer !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>nummer, 'nummer');
        }
        if (nummerZusatz !== undefined && nummerZusatz !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>nummerZusatz, 'nummerZusatz');
        }
        if (nummer3 !== undefined && nummer3 !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>nummer3, 'nummer3');
        }
        if (nummer4 !== undefined && nummer4 !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>nummer4, 'nummer4');
        }
        if (bfsNummer !== undefined && bfsNummer !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>bfsNummer, 'bfsNummer');
        }
        if (kreisNummer !== undefined && kreisNummer !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>kreisNummer, 'kreisNummer');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Array<GrundstueckFlaechenanteilMasterDetailEntry>>(`${this.configuration.basePath}/av/flaechenanteil/fachid`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
